// Offline-queue change subscription — a window CustomEvent so the badge / open
// lists refresh the moment the queue grows or drains.
//
// Extracted from offlineQueue.ts (Phase 3b, step 3). Leaf module — depends only
// on window. installQueueFlusher stays in offlineQueue.ts (it calls drainQueue).

const CHANGED_EVENT = 'kf49:offline-queue-changed'

export function notifyChanged(): void {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent(CHANGED_EVENT))
}

export function onQueueChanged(handler: () => void): () => void {
  window.addEventListener(CHANGED_EVENT, handler)
  return () => window.removeEventListener(CHANGED_EVENT, handler)
}
